import { render } from "./PasswordOTPVerification.vue?vue&type=template&id=278a3b94&scoped=true"
import script from "./PasswordOTPVerification.vue?vue&type=script&lang=js"
export * from "./PasswordOTPVerification.vue?vue&type=script&lang=js"

import "./PasswordOTPVerification.vue?vue&type=style&index=0&id=278a3b94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278a3b94"]])

export default __exports__